module.exports = __webpack_public_path__ + "img/tnt-og.bc99c5d6.jpg";